module.exports = __webpack_public_path__ + "0cd67832ada299150bc86f3dae46b37b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB-SCT.svg
// module id = nTQh
// module chunks = 0